import axios from 'axios';
axios.defaults.baseURL = '/';
axios.defaults.withCredentials = true;
axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8;';
class MiRequest {
    instance;
    constructor() {
        this.instance = this;
        this.register();
    }
    register() {
        const methods = [
            'get',
            'post',
            'put',
            'patch',
            'delete',
            'options',
            'head',
            'link',
            'unlink',
            'purge'
        ];
        methods.forEach((method) => {
            this.instance[method.toLowerCase()] = (url, data = {}, config) => {
                const args = {
                    url,
                    data,
                    method: method.toUpperCase(),
                    retry: 0,
                    retryDelay: 1000,
                    retryCount: (config && config.retryCount) || 0
                };
                if (method.toUpperCase() === 'GET') {
                    delete args.data;
                    args.params = data;
                }
                const configuration = {
                    ...args,
                    ...config
                };
                return this.send(configuration);
            };
        });
    }
    async send(config) {
        if (!config.timeout)
            config.timeout = 60000;
        return await axios(config)
            .then((res) => {
            return Promise.resolve(res?.data);
        })
            .catch((err) => {
            return Promise.reject(err);
        });
    }
}
export const $request = new MiRequest();
export default {
    install(app) {
        app.config.globalProperties.$request = $request;
        app.provide('$request', $request);
        return app;
    }
};
